<template>
  <portlet
      :icon="'fad fa-users'"
      :title="'Kandidaten'"
      :actionsBlock="true"
  >
    <template slot="actionsBlock">
      <router-link v-if="Can(rights.CANDIDATE_ADD)" tag="button" :to="{name:'candidate-create'}"
                   class="btn btn-secondary">
        <i class="fas fa-plus-circle mr-2"></i> Toevoegen
      </router-link>
      <a @click="createGroupSMS()">
        <button class="btn btn-primary mr-4">
          <i class="fal fa-sms mr-2"></i> SMS verzenden
        </button>
      </a>
      <a :href="$CLOUD_API+'/export/candidates?access_token=' + this.$store.state.oAuthToken" v-if="isAdmin">
        <button class="btn btn-primary mr-4">
          <i class="fas fa-file-excel mr-2"></i> Exporteren naar Excel
        </button>
      </a>

      <a @click="reset()">
        <button class="btn btn-primary mr-4">
          <i class=" fas fa-sync"></i> reset filter
        </button>
      </a>


    </template>

    <template slot="portletBody">
      <button class="m-show-lg btn btn-secondary w-100 mb-4" @click="filterOpen = !filterOpen">
        <i class="far mr-3" :class="{'fa-filter': !filterOpen, 'fa-times': filterOpen }"></i>
        <template v-if="!filterOpen">
          Filter kandidaten
        </template>
        <template v-else>
          Sluit filter
        </template>
      </button>


      <div class="row dataTable-filters mb-5" :class="filterOpenClass">

        <div class="col-md-4 col-xl-2">
          <div class="dropdown">
            <button class="btn btn-primary dropdown-toggle" type="button">
              <span>Geslacht </span>
            </button>
            <div class="dropdown-menu">

              <div class="option-wrapper">
                <div class="custom-control custom-checkbox"
                     v-for="(gender, index) in ['Man','Vrouw','Ik weet het nog niet']"
                     :key="gender+'-'+index">
                  <input v-model="customFilters[7].options.values"
                         :value="gender"
                         type="checkbox"
                         :id="gender+'-'+index"
                         class="custom-control-input"
                  >
                  <label class="custom-control-label" :for="gender+'-'+index">
                    <span>{{ gender }}</span>
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-4 col-xl-2">
          <div class="dropdown">
            <button class="btn btn-primary dropdown-toggle" type="button">
              <span>Persoon ({{ customFilters[0].options.values.length }})</span>
            </button>
            <div class="dropdown-menu">
              <input class="form-control mb-3" type="text" placeholder="Zoeken.."
                     v-model="searchName">
              <div class="option-wrapper">
                <div class="custom-control custom-checkbox"
                     v-for="(candidate, index) in searchByName"
                     :key="candidate+'-'+index">
                  <input v-model="customFilters[0].options.values"
                         :value="candidate.id"
                         type="checkbox"
                         :id="candidate.fullName+'-'+index"
                         class="custom-control-input"
                  >
                  <label class="custom-control-label" :for="candidate.fullName+'-'+index">
                    <span>{{ candidate.fullName }}</span>
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-4 col-xl-2">
          <div class="dropdown">
            <button class="btn btn-primary dropdown-toggle" type="button">
              Ervaring ({{ customFilters[1].options.values.length }})
            </button>
            <div class="dropdown-menu">
              <div class="option-wrapper-large">
                <div class="custom-control custom-checkbox"
                     v-for="(experience, index) in getExperiences"
                     :key="experience+'-'+index">
                  <input v-model="customFilters[1].options.values"
                         :value="experience"
                         type="checkbox"
                         :id="experience+'-'+index"
                         class="custom-control-input"
                  >
                  <label class="custom-control-label" :for="experience+'-'+index">
                    <span>{{ experience }}</span>
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-4 col-xl-2">
          <div class="dropdown">
            <button class="btn btn-primary dropdown-toggle" type="button">
              Ploegen ({{ customFilters[2].options.values.length }})
            </button>
            <div class="dropdown-menu">
              <div class="custom-control custom-checkbox"
                   v-for="(shift, index) in getStandardFormChoices('shifts')"
                   :key="shift+'-'+index">
                <input v-model="customFilters[2].options.values"
                       :value="shift"
                       type="checkbox"
                       :id="'shift-'+index"
                       class="custom-control-input"
                >
                <label class="custom-control-label" :for="'shift-'+index">{{ shift }}</label>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-4 col-xl-2">
          <div class="dropdown">
            <button class="btn btn-primary dropdown-toggle" type="button">
              Geplaatst
            </button>
            <div class="dropdown-menu">
              <div class="custom-control custom-checkbox"
                   v-for="(placed, index) in [true,false]"
                   :key="placed+'-'+index">
                <input v-model="customFilters[6].options.values"
                       :value="placed"
                       type="checkbox"
                       :id="'placed-'+index"
                       class="custom-control-input"
                >
                <label class="custom-control-label" :for="'placed-'+index">{{ placed ? 'Ja' : 'Nee' }}</label>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-4 col-xl-2">
          <div class="dropdown">
            <button class="btn btn-primary dropdown-toggle" type="button">
              Overname
            </button>
            <div class="dropdown-menu">
              <div class="custom-control custom-checkbox"
                   v-for="(takenOver, index) in [true,false]"
                   :key="'takenOver-'+takenOver">
                <input v-model="customFilters[10].options.values"
                       :value="takenOver"
                       type="checkbox"
                       :id="'takenOver-'+index"
                       class="custom-control-input"
                >
                <label class="custom-control-label" :for="'takenOver-'+index">{{ takenOver ? 'Ja' : 'Nee' }}</label>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-4 col-xl-2 salary-range-filter">
          <label for="salaryRange" class="mb-1">Salaris Min</label>
          <vue-slider
              v-model="salaryMin"
              id="salaryRange"
              :min="1"
              :max="getSalaryMin"
              :interval="0.5"
              :tooltip="'always'"
              :tooltip-placement="'bottom'"
              :silent="true"
              @change="setValueSalary"
          >
          </vue-slider>
        </div>
        <div class="col-md-4 col-xl-2">
          <div class="dropdown">
            <button class="btn btn-primary dropdown-toggle" type="button">
              <span>{{ ageFilterLabel }}</span>
            </button>
            <div class="dropdown-menu">
              <div class="form-group">
                <label class="mb-1" for="age-min">Min</label>
                <input type="number" min="0" class="form-control" id="age-min" placeholder="Min"
                       v-model.number="customFilters[9].options.range.min">
              </div>
              <div class="form-group mb-0">
                <label class="mb-1" for="age-max">Max</label>
                <input type="number" min="0" class="form-control" id="age-max" placeholder="Max"
                       v-model.number="customFilters[9].options.range.max">
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row dataTable-filters mt-5 mb-5" style="margin-top:4rem!important;" :class="filterOpenClass">
        <div class="col-md-4 col-xl-2">
          <div class="dropdown">
            <button class="btn btn-primary dropdown-toggle" type="button">
              Vervoer ({{ customFilters[4].options.values.length }})
            </button>
            <div class="dropdown-menu">
              <div class="custom-control custom-checkbox"
                   v-for="(transport, index) in getStandardFormChoices('transports')"
                   :key="transport+'-'+index">
                <input v-model="customFilters[4].options.values"
                       :value="transport"
                       type="checkbox"
                       :id="transport+'-'+index"
                       class="custom-control-input"
                >
                <label class="custom-control-label" :for="transport+'-'+index">
                  <span>{{ transport }}</span>
                </label>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-4 col-xl-2">
          <div class="dropdown">
            <button class="btn btn-primary dropdown-toggle" type="button">
              Taal ({{ customFilters[8].options.values.length }})
            </button>
            <div class="dropdown-menu">
              <div class="custom-control custom-checkbox"
                   v-for="(language, index) in getStandardFormChoices('language')"
                   :key="language+'-'+index">
                <input v-model="customFilters[8].options.values"
                       :value="language"
                       type="checkbox"
                       :id="language+'-'+index"
                       class="custom-control-input"
                >
                <label class="custom-control-label" :for="language+'-'+index">
                  <span>{{ language }}</span>
                </label>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-4 col-xl-2">
          <input id="getGeoLocation"
                 type="text"
                 class="form-control"
                 :class="{'is-invalid': checkZipCode}"
                 v-model.trim="zipcode"
                 placeholder="1234 AB"
          >
          <span v-if="checkZipCode" class="small text-danger">Postcode is onjuist</span>
        </div>
        <div class="col-md-4 col-xl-4">
        </div>
        <div class="col-md-4 col-xl-2">
          <div class="dropdown">
            <button class="btn btn-primary dropdown-toggle" type="button">
              Kolommen weergave
            </button>
            <div class="dropdown-menu">
              <div class="custom-control custom-checkbox"
                   v-for="(col,index) in getShowableColumns"
                   :key="col+'-'+index">
                <input
                    v-model="showableColumns"
                    :value="col.name"
                    type="checkbox"
                    :id="'col-'+index"
                    class="custom-control-input      "
                >
                <label class="custom-control-label" :for="'col-'+index">{{ col.name }}</label>
              </div>

            </div>
          </div>
        </div>
      </div>
      <div class="modal fade" id="group-sms" aria-labelledby="group-sms" tabindex="-1" role="dialog"
           aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered lg">
          <div class="modal-content">
            <div class="modal-header">
              <h4 class="modal-title">Groep sms</h4>
              <button type="button" class="close" data-dismiss="modal" aria-hidden="true">×</button>
            </div>
            <div class="modal-body">
              <p>Bericht wordt verzonden aan <b>{{ smsCandidates.length }}</b> candidaten</p>
              <label for="message">Bericht <span
                  style="opacity:0.5">nog {{
                  smsMessageLength - smsMessage.length >= 0 ? smsMessageLength - smsMessage.length : 0
                }} karakters vereist </span></label>
              <textarea name="message" v-model="smsMessage" id="message" cols="30" rows="10"
                        class="form-control"></textarea>
            </div>
            <div class="modal-footer">
              <button type="button" @click="sendSms()" class="btn btn-primary">Verstuur SMS</button>
              <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
            </div>
          </div>
        </div>
      </div>
      <div class=" table-responsive">
        <datatables
            :tableClass="tableClass"
            v-if="getCandidates.length && renderedComponent && Can(rights.CANDIDATE_VIEW)"
            :rows="getCandidatesWithPlacementNowOrInFuture"
            :columns="getColumns"
            tableID="candidates"
            ref="TABLE"
            :tableInitOptions="tableInitOptions"
            :customFilters="customFilters"
            routerLinkClass="dt-router-link"
            :deleteFunction="deleteCandidate"
            deleteClass="delete"
            @rowSelected="searchVacancy"
        ></datatables>

      </div>
    </template>

  </portlet>
</template>

<script>
import {mapGetters} from 'vuex';
import {getGeoLocation} from '../../components/mixins/getGeoLocation';
import {dataTables} from '../../components/mixins/dataTables';
import {swalModals} from '../../components/mixins/swalModals.js';
import {Can} from '../../../permission/ability.js';
import {RIGHTS} from '../roles/rights';


export default {
  mixins: [getGeoLocation, dataTables, swalModals],
  data() {
    return {
      isAdmin: false,
      filterOpen: false,
      filterOpenClass: 'm-hide-lg',
      searchName: '',
      showableColumns: ['Geplaatst', 'Persoon', 'Leeftijd', 'Ervaringen', 'Ploegen', 'Max. afstand', 'Salaris', 'Vervoer', 'Ziek', 'Inschrijfdatum', 'Duur'],

      salaryMin: null,
      zipcode: null,
      checkZipCode: false,
      columns: [
        {
          data: null, name: 'Geplaatst', visible: true, searchable: true, responsivePriority: 1,
          render(data) {
            return data.activePlacement === true ? 'Ja' : 'Nee';
          }
        }, {
          data: null, name: 'Persoon', visible: true, searchable: true, responsivePriority: 1,
          render(data) {
            return '<a data-to="/candidates/' + data.id + '" class="dt-router-link">' + data.firstName + ' ' + data.lastName + '</a>';
          }
        },
        {data: 'experiences[, ]', name: 'Ervaringen', visible: true, searchable: true},
        {data: 'shifts[, ]', name: 'Ploegen', visible: true, searchable: true},
        {
          data: 'travelDistance', name: 'Max. afstand', visible: true, searchable: true,
          render(data, type) {
            if (type !== 'display') {
              return parseFloat(data);
            } else {
              return data + ' km';
            }
          }
        },
        {
          data: null, name: 'Salaris', visible: true, searchable: true,
          render(data) {
            return '€ ' + data.salaryMin
            //  return '€ ' + (data.salaryMin ? data.salaryMin : '') + ' - ' + (data.salaryMax ? data.salaryMax : '');
          }
        },
        {data: 'transports[, ]', name: 'Vervoer', visible: true, searchable: true},
        {
          data: 'sick', name: 'Ziek', visible: true,
          render(data) {
            if (data) {
              return '<i class="fas fa-user-md" title="Kandidaat is ziek"></i>';
            } else {
              return '';
            }

          }
        },
        {
          data: null, name: 'Opties', orderable: false, responsivePriority: 2,
          render(data) {
            if (data.blacklisted) {
              return '<a data-to="/candidates/' + data.id + '" class="action-icon dt-router-link"><i title="Aanpassen" class="far fa-edit"></i></a>' +
                  '<a class="delete action-icon dt-router-link" data-id="' + data.id + '"><i title="Verwijder" class="far fa-trash-alt delete"></i></a>' +
                  '<i title="Staat op blacklist" class="far fa-exclamation-triangle action-icon"></i>';
            } else {
              return '<a data-to="/candidates/' + data.id + '" class="action-icon dt-router-link"><i title="Aanpassen" class="far fa-edit"></i></a>' +
                  '<a class="delete action-icon " data-id="' + data.id + '"><i title="Verwijder" class="far fa-trash-alt delete"></i></a>' +
                  '<i title="Vacature zoeken" class="far fa-search action-icon get-data"></i>';
            }
          }
        },

        {data: 'geoLocation.lat', name: 'geoLat', visible: false, searchable: false},
        {data: 'geoLocation.lng', name: 'geoLng', visible: false, searchable: false}
      ],
      customFilters: [
        {
          filter: 'arrayContains',
          keyToFilter: 'id',
          options: {
            keyToFilter: null,
            values: []
          }
        },
        {
          filter: 'arrayHas',
          keyToFilter: 'experiences',
          options: {
            keyToFilter: null,
            values: []
          }
        },
        {
          filter: 'arrayContains',
          keyToFilter: 'shifts',
          options: {
            keyToFilter: null,
            values: []
          }
        },
        {
          filter: 'greaterThan',
          keyToFilter: 'salaryMin',
          options: {
            min: 0
          }
        },
        {
          filter: 'arrayContains',
          keyToFilter: 'transports',
          options: {
            keyToFilter: null,
            values: []
          }
        },
        {
          filter: 'getDistanceFromGeoCoord',
          keyToFilter: 'geoLocation',
          keyToFilterRange: 'travelDistance',
          options: {
            range: {max: 0, min: 0},
            coordsFrom: null
          }
        },
        {
          filter: 'arrayContains',
          keyToFilter: 'activePlacement',
          options: {
            keyToFilter: null,
            values: []
          }
        },
        {
          filter: 'arrayContains',
          keyToFilter: 'gender',
          options: {
            keyToFilter: null,
            values: []
          }
        },
        {
          filter: 'arrayContains',
          keyToFilter: 'language',
          options: {
            keyToFilter: null,
            values: []
          }
        },
        {
          filter: 'rangeFilter',
          keyToFilter: 'age',
          options: {
            range: {
              min: null,
              max: null
            }
          }
        },
        {
          filter: 'arrayContains',
          keyToFilter: 'takenOver',
          options: {
            keyToFilter: null,
            values: []
          }
        }
      ],
      smsMessage: '',
      smsMessageLength: 20,
      smsCandidates: []
    };
  },
  methods: {
    Can,
    checkIfVisible(name) {
      return _.includes(this.showableColumns, name);
    },

    setValueSalary(value) {
      this.customFilters[3].options.min = value;
      return value;
    },

    deleteCandidate(data) {
      let name = data.firstName + ' ' + data.lastName;
      this.swalDelete(name).then(result => {
        if (result.value) {
          this.$store.dispatch('candidates/delete', data.id).then(() => {
            this.renderComponent();
            this.$toasted.global.successRequest({
              message: 'Kandidaat verwijderd'
            });
          });
        }
      });
    },
    reset() {
      this.resetFilter(['candidates-filter-state']);
      this.zipcode = '';
      this.salaryMin = this.getSalaryMin;
      this.customFilters[9].options.range = {min: null, max: null};
      this.showableColumns = ['Geplaatst', 'Persoon', 'Leeftijd', 'Ervaringen', 'Ploegen', 'Max. afstand', 'Salaris', 'Vervoer', 'Ziek', 'Inschrijfdatum', 'Duur'],
          document.dispatchEvent(new CustomEvent('dataTables-searchProgrammatically'));
    },
    searchVacancy(value) {
      let candidateObj = value;
      this.$router.push({name: 'vacancies', params: {candidateObj}});
    },
    createGroupSMS() {
      this.smsCandidates = $('#candidates').DataTable().rows({filter: 'applied'}).data().toArray();

      if (this.smsCandidates.length < 1) {
        this.$toasted.global.failedRequest({message: 'Geen candidaten'});
      } else {
        $('#group-sms').modal('show');
      }
    },
    sendSms() {
      if (this.smsMessage.length < 20) {
        return this.$toasted.global.failedRequest({message: 'TE KORTE SMS'});
      }
      if (this.smsCandidates.length < 1) {
        this.$toasted.global.failedRequest({message: 'Geen candidaten'});
      }
      let smsData = {
        candidates: this.smsCandidates.map(candidate => {
          return {id: candidate.id, telephone: candidate.telephone};
        }),
        status: 'pending',
        message: this.smsMessage,
        sentBy: this.getUserData,
        department: this.getUserData.selectedDepartment,
      };
      this.$store.dispatch('smsHistory/insert', smsData).then(response => {
        $('#group-sms').modal('hide');
        this.smsMessage = '';
        this.smsCandidates = [];
        this.$toasted.global.successRequest({message: 'SMS aangemaakt en wacht op verzending'});
      });
    }
  },
  computed: {
    getShowableColumns() {
      return this.getColumns.filter(column => {
        if (!_.includes(['Persoon', 'Opties', 'geoLat', 'geolng'], column.name)) {
          return column
        }
      });
    },
    ...mapGetters([
      'getUserData'
    ]),
    ...mapGetters('candidates', [
          'getCandidates',
          'getStandardFormChoices',
          'getCandidateFullName',
          'getExperiences',
          'getSalaryMin',
          'getCandidatesWithPlacementNowOrInFuture'
        ]
    ),
    ...mapGetters('customers', ['getCustomers']),
    searchByName() {
      return this.getCandidateFullName.filter((search) => {
        return search.fullName.toLowerCase().indexOf(this.searchName.toLowerCase()) >= 0;
      });
    },
    ageFilterLabel() {
      const {min, max} = this.customFilters[9].options.range;
      const hasMin = min !== null && min !== '' && min !== undefined;
      const hasMax = max !== null && max !== '' && max !== undefined;
      if (hasMin && hasMax) return `Leeftijd (${min} - ${max})`;
      if (hasMin) return `Leeftijd (vanaf ${min})`;
      if (hasMax) return `Leeftijd (tot ${max})`;
      return 'Leeftijd';
    },
    getColumns() {
      var self = this
      return [
        {
          data: null, name: 'Geplaatst', visible: self.checkIfVisible('Geplaatst'), searchable: true,
          width: '5%', responsivePriority: 1,
          render(data) {
            return data.activePlacement === true ? 'Ja' : 'Nee';
          }
        }, {
          data: null, name: 'Persoon', visible: self.checkIfVisible('Persoon'), searchable: true, responsivePriority: 1,
          render(data) {
            return '<a data-to="/candidates/' + data.id + '" class="dt-router-link">' + data.firstName + ' ' + data.lastName + '</a>';
          }
        },
        {
          data: 'age', name: 'Leeftijd', visible: self.checkIfVisible('Leeftijd'), searchable: true,
          render(data, type) {
            if (type !== 'display') {
              return data;
            }
            return data !== null && data !== undefined ? data : '';
          }
        },
        {
          data: 'experiences[, ]', name: 'Ervaringen',

          visible: self.checkIfVisible('Ervaringen'), searchable: true
        },
        {
          data: 'shifts[, ]', name: 'Ploegen',
          responsivePriority: 1000,
          visible: self.checkIfVisible('Ploegen'), searchable: true
        },
        {
          data: 'travelDistance', name: 'Max. afstand', visible: self.checkIfVisible('Max. afstand'), searchable: true,
          render(data, type) {
            if (type !== 'display') {
              return parseFloat(data);
            } else {
              return data + ' km';
            }
          }
        },
        {
          data: null, name: 'Min. Salaris', visible: self.checkIfVisible('Salaris'), searchable: true,
          render(data) {
            return '€ ' + data.salaryMin
            // return '€ ' + (data.salaryMin ? data.salaryMin : '') + ' - ' + (data.salaryMax ? data.salaryMax : '');
          }
        },
        {data: 'transports[, ]', name: 'Vervoer', visible: self.checkIfVisible('Vervoer'), searchable: true},
        {
          data: 'sick', name: 'Ziek', visible: self.checkIfVisible('Ziek'),
          render(data) {
            if (data) {
              return '<i class="fas fa-user-md" title="Kandidaat is ziek"></i>';
            } else {
              return '';
            }

          }
        },
        {
          data: null, name: 'Inschrijfdatum', visible: self.checkIfVisible('Inschrijfdatum'),
          sortable: true,
          render(data, type) {
            if (data) {
              if (type == 'sort') {
                return moment(data.created_at).unix()
              }
              return moment(data.created_at).format('DD-MM-YYYY');
            } else {
              return '';
            }
          }
        },
        {
          data: null,
          responsivePriority: 1,
          name: 'Duur', visible: self.checkIfVisible('Duur'),
          sortable: true,
          type: 'number',
          width: '100px',
          render(data, type) {
            /*
            calculate from 130 days
            60 = 60% then orange
            120 - 90 %
             */
            let html = ''
            let progress = 0
            if (data.activePlacement) {

              let placements = data.activePlacementData
              for (let i = 0; i < placements.length; i++) {
                let start = moment(placements[i].startDate);

                let end = moment();
                if (start.isSameOrBefore(moment())) {

                  if (i > 0 && html.length) {
                    html += '<br>'
                  }

                  // let customerName = placements[i].customer.name;
                  let diffInDays = end.diff(start, 'days');

                  if (diffInDays < 0) {
                    diffInDays = 0
                  }
                  if (diffInDays > progress) {
                    progress = diffInDays
                  }
                  let progressClass = diffInDays < 60 ? 'bg-success' : diffInDays < 120 ? 'bg-warning' : 'bg-danger';

                  let newHtml = `<div class="progress">
  <div class="progress-bar ${progressClass}" role="progressbar" style="width: ${diffInDays / 130 * 100}%;" aria-valuenow="${diffInDays}" aria-valuemin="0" aria-valuemax="130">
<span >${diffInDays} dagen </span>
</div>
</div>`
                  html += newHtml
                }
              }
            } else {
              html += `<div class="progress">
                <div class="progress-bar bg-success " role="progressbar" style="width: 0%;" aria-valuenow="0" aria-valuemin="0" aria-valuemax="130">
                  <span >0 dagen </span>
                </div>
              </div>`
            }

            if (type == 'sort') {
              return progress
            }
            if (!html) {
              html = `<div class="progress">
                <div class="progress-bar bg-success " role="progressbar" style="width: 0%;" aria-valuenow="0" aria-valuemin="0" aria-valuemax="130">
                  <span >0 dagen </span>
                </div>
              </div>`
            }
            return html;

          }
        },
        {
          data: null, name: 'Opties',
          orderable: false, responsivePriority: 2,
          render(data) {
            var options = '';
            if (Can(RIGHTS.CANDIDATE_EDIT)) {
              options += '<a data-to="/candidates/' + data.id + '" class="action-icon dt-router-link"><i title="Aanpassen" class="far fa-edit"></i></a>';
            }

            if (Can(RIGHTS.CANDIDATE_DELETE)) {
              if (data.blacklisted) {
                options += '<a class="delete action-icon dt-router-link" data-id="' + data.id + '"><i title="Verwijder" class="far fa-trash-alt delete"></i></a>';
              } else {
                options += '<a class="delete action-icon " data-id="' + data.id + '"><i title="Verwijder" class="far fa-trash-alt delete"></i></a>';
              }
            }

            if (data.blacklisted) {
              options += '<i title="Staat op blacklist" class="far fa-exclamation-triangle action-icon"></i>'
            } else {
              options += '<i title="Vacature zoeken" class="far fa-search action-icon get-data"></i>'
            }

            return options;
          }

        },

        {
          data: null,
          name: 'geoLat', visible: false, searchable: false,
          render(data) {
            let geo = data.geoLocation ? data.geoLocation.lat : null
            return geo
          }
        },
        {
          data: null,
          name: 'geolng', visible: false, searchable: false,
          render(data) {
            let geo = data.geoLocation ? data.geoLocation.lng : null
            return geo
          }
        },
      ]
    },
  },
  watch: {
    'filterOpen': function (value) {
      if (value) {
        this.filterOpenClass = 'm-show-flex-lg';
      } else {
        this.filterOpenClass = 'm-hide-lg';
      }
    },
    salaryMin(after) {
      localStorage.setItem('candidates-filter-state', JSON.stringify(this.customFilters));
    },
    'getSalaryMin': function () {
      this.salaryMin = isNaN(this.getSalaryMin) ? 0 : this.getSalaryMin;
    },
    'zipcode': function (zipcode) {
      let regex = new RegExp('^[1-9][0-9]{3}\s?([a-zA-Z]{2})?$');

      let trimmedZip = zipcode.replace(/\s/g, '');
      if (trimmedZip.length === 6 && regex.test(trimmedZip)) {
        this.getGeoLocationfromPostal(trimmedZip).then((res) => {
          let geoData = res.data.results[0];
          if (geoData) {
            this.customFilters[5].options.coordsFrom = geoData.geometry.location;
            this.checkZipCode = false;
          } else {
            this.checkZipCode = true;
          }
        });
      } else if (trimmedZip.length > 6) {
        this.checkZipCode = true;
      } else {
        this.customFilters[5].options.coordsFrom = null;
      }
    },
    'customFilters': {
      handler: function (after, before) {
        //store daterange
        localStorage.setItem('candidates-filter-state', JSON.stringify(after));

      },
      deep: true
    }
  },
  created() {
    this.rights = RIGHTS;
    this.isAdmin = this.$store.state.users.me.admin;
    let vacancyObj = this.$route.params.vacancyObj;

    if (vacancyObj) {
      this.customFilters[1].options.values = vacancyObj.experiences.filter(i => this.getExperiences.indexOf(i) !== -1);
      this.customFilters[2].options.values = vacancyObj.shifts;
      this.customFilters[3].options.min = vacancyObj.salaryFrom;

      // this.customFilters[3].options.range.max = vacancyObj.salaryTo;
      this.salaryMin = parseInt(vacancyObj.salaryFrom);
      this.customFilters[5].options.coordsFrom = vacancyObj.geoLocation;

      this.zipcode = vacancyObj.zipcode;
    } else {
      let customFilterState = localStorage.getItem('candidates-filter-state');
      if (customFilterState) {
        this.customFilters = JSON.parse(customFilterState);
        if (!this.customFilters[6]) {
          this.customFilters.push(
              {
                filter: 'arrayContains',
                keyToFilter: 'activePlacement',
                options: {
                  keyToFilter: null,
                  values: []
                }
              });
        }
        if (!this.customFilters[7]) {
          this.customFilters.push(
              {
                filter: 'arrayContains',
                keyToFilter: 'gender',
                options: {
                  keyToFilter: null,
                  values: []
                }
              })
        }
        if (!this.customFilters[8]) {
          this.customFilters.push(
              {
                filter: 'arrayContains',
                keyToFilter: 'language',
                options: {
                  keyToFilter: null,
                  values: []
                }
              })
        }
        if (!this.customFilters[9]) {
          this.customFilters.push(
              {
                filter: 'rangeFilter',
                keyToFilter: 'age',
                options: {
                  range: {
                    min: null,
                    max: null
                  }
                }
              })
        }
        if (!this.customFilters[10]) {
          this.customFilters.push(
              {
                filter: 'arrayContains',
                keyToFilter: 'takenOver',
                options: {
                  keyToFilter: null,
                  values: []
                }
              })
        }
        let salary = this.customFilters[3].options;
        this.salaryMin = salary.min;
      } else {
        this.salaryMin = this.getSalaryMin;
      }

    }
    // this.renderComponent()
  }
};
</script>
<style lang="scss" scoped>
.dataTable-filters {
  row-gap: 1rem;
}

/deep/ .progress {
  background: #b4b4b4;
}

/deep/ .progress-bar {

  span {
    margin: 5px;
    padding: 2px;
    color: white;
    font-size: 14px;
    font-weight: 600;
  }
}
</style>